import { useState } from 'react';

import { tracking } from '@iwoca/frontend-tracking-library';
import { IconPlus } from '@iwoca/icons';
import { Button } from '@iwoca/orion-ui';
import { FormattedMessage } from 'react-intl';

import AgreeDirectDebitMandateModal from '../../../../modals/agreeDirectDebitMandateModal/AgreeDirectDebitMandateModal';
import StepItem from '../../stepItem/StepItem';

export const AddNewAccount = ({
    triggerRefetchFundingRequirements
}: {
    triggerRefetchFundingRequirements: () => void;
}) => {
    const [isDirectDebitMandateModalOpen, setIsDirectDebitMandateModalOpen] =
        useState(false);

    return (
        <>
            <AgreeDirectDebitMandateModal
                isModalOpen={isDirectDebitMandateModalOpen}
                onClose={() => {
                    setIsDirectDebitMandateModalOpen(false);
                    triggerRefetchFundingRequirements();
                }}
            />
            <StepItem
                title={
                    <FormattedMessage
                        id="_.funding_requirements.add_bank_details_title"
                        defaultMessage="Add your business bank details"
                    />
                }
                caption={
                    <FormattedMessage
                        id="_.funding_requirements.add_bank_details.add_new_funding_account_caption"
                        defaultMessage="For payout and direct debit"
                    />
                }
                action={
                    <Button
                        variant="primary"
                        onClick={() => {
                            tracking.ampli.addBankDetailsAddNewAccountClicked();
                            setIsDirectDebitMandateModalOpen(true);
                        }}
                    >
                        <FormattedMessage
                            id="_.funding_requirements.add_bank_details.add_new_funding_account"
                            defaultMessage="Add now"
                        />
                        <IconPlus />
                    </Button>
                }
            />
        </>
    );
};
